import { InfoLinksCard, ExtraSettingsCard } from "@/components/agent/details";
import { CoreDrawer } from "@/components/common/CoreDrawer";
import { Agent } from "@/types/agent/agent";

interface ConversationDrawerProps {
  genie: Agent;
  isOpen: boolean;
  onClose: () => void;
}

export default function ConversationDrawer({ genie, isOpen, onClose }: ConversationDrawerProps) {
  const brand = genie.branding?.primaryColor ?? "#4E9CFF";

  return (
    <CoreDrawer
      isOpen={isOpen}
      onClose={onClose}
      title="Conversation"
      description="Configure info links and extra conversation settings."
    >
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-6 xl:items-stretch">
        <InfoLinksCard agent={genie} brand={brand} />
        <ExtraSettingsCard agent={genie} brand={brand} />
      </div>
    </CoreDrawer>
  );
}
